<template>
    <div class="main-content">
        <PageHeader marginClasses="mx-9">
            <template #left>
            <Link class="flex items-center text-gray-500 hover:text-teal transition-colors" :href="`${props.urlPrefix}/stories/all`" v-if="stories.length > 1">
                <span class="iconify" data-icon="ph:caret-left-fill"></span>
                <span class="uppercase font-semibold text-xs ml-1">ALL STORIES</span>
            </Link>
            </template>
        </PageHeader>

        <article class="pt-9 pb-16 px-9 grid gap-8 max-w-[680px] mx-auto">

            <div class="article-header flex justify-center items-center" v-if="story.location">


                <h4 class="font-extrabold text-[#777] uppercase tracking-wider font-sans text-[.86rem]" v-html="story.location"></h4>
            </div>

            <template v-for="(block, index) in story.blocks" :key="index">
                <section class="prose row-editor" :class="[ 'block-'+index ]" v-if="block.type == 'html'" v-html="block.content" />

                 <GridBlock v-if="block.type == 'grid'" :class="[ 'block-'+index ]" :grid="block"></GridBlock>

                    <div class="row-blockquote" :class="[ 'block-'+index ]" v-if="block.type == 'blockquote'">
                        <div class="blockquote-bg">
                            <img src="data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1s bnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJ IHZpZXdCb3g9IjAgMCAyMTcuMiAxNjAuMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAw IDAgMjE3LjIgMTYwLjI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQv Y3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojRjJGM0Y0O3N0cm9rZS13aWR0aDozO3N0cm9r ZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9Cjwvc3R5bGU+CjxwYXRoIGNs YXNzPSJzdDAiIGQ9Ik02NC40LDEyNy42YzguMS05LjQsMTMtMTguOSwxNC42LTI4LjdjMC45LTUu MSwxLjQtOS42LDEuNC0xMy4yYzAtNC4yLTAuNS03LjctMS40LTEwLjUKCWMtOC42LDktMTkuNiwx My41LTMyLjgsMTMuNWMtMTMuMiwwLTI0LTMuOS0zMi4zLTExLjZjLTguMy03LjctMTIuNC0xOC40 LTEyLjQtMzJjMC0xMi45LDQuNC0yMy40LDEzLjEtMzEuNAoJQzIzLjMsNS41LDM0LjQsMS41LDQ3 LjgsMS41YzE4LjQsMCwzMS44LDYuNiw0MC4zLDE5LjljMy45LDUuNyw2LjksMTIuNyw5LjEsMjEu MWMyLjIsOC40LDMuMywxNywzLjMsMjUuOGMwLDE5LjMtNSwzNy0xNC45LDUzCgljLTkuOSwxNi0y NC43LDI4LjUtNDQuNCwzNy41TDM2LDE0OC41QzQ2LjgsMTQzLjksNTYuMywxMzYuOSw2NC40LDEy Ny42eiIvPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTc5LjUsMTI3LjZjOC4xLTkuNCwxMy0xOC45 LDE0LjYtMjguN2MwLjktNS4xLDEuNC05LjYsMS40LTEzLjJjMC00LjItMC41LTcuNy0xLjQtMTAu NQoJYy04LjYsOS0xOS42LDEzLjUtMzIuOCwxMy41Yy0xMy4yLDAtMjQtMy45LTMyLjMtMTEuNmMt OC4zLTcuNy0xMi40LTE4LjQtMTIuNC0zMmMwLTEyLjksNC40LTIzLjQsMTMuMS0zMS40CgljOC43 LTguMSwxOS44LTEyLjEsMzMuMi0xMi4xYzE4LjQsMCwzMS44LDYuNiw0MC4zLDE5LjljMy45LDUu Nyw2LjksMTIuNyw5LjEsMjEuMWMyLjIsOC40LDMuMywxNywzLjMsMjUuOGMwLDE5LjMtNSwzNy0x NC45LDUzCgljLTkuOSwxNi0yNC43LDI4LjUtNDQuNCwzNy41bC01LjItMTAuMkMxNjIsMTQzLjks MTcxLjQsMTM2LjksMTc5LjUsMTI3LjZ6Ii8+Cjwvc3ZnPg==" >
                        </div>
                        <div class="blockquote-body">
                            <div class="blockquote-input" v-html="block.content">
                            </div>
                        </div>
                    </div>
            </template>

            <div class="bottom-nav-wrapper text-zinc-300 relative pt-8 pb-8 border-top-dotted border-bottom-dotted border-opacity-70"  v-if="stories.length > 1">

                <!--<svg class="line-border text-gray-400 flex-grow h-[2px] z-[-1] w-full">
                        <line x1="0" y1="50%" x2="100%" y2="50%"  />
                </svg>-->
                <div class="article-nav text-body w-full justify-between flex items-center">
                    <Link :href="`${props.urlPrefix}/stories/${prevStory.slug}`" class="nav-item group pr-[15px] transition-opacity hover:opacity-80 duration-300 relative w-1/2 max-w-[215px] flex flex-col items-start">
                        <span class="flex items-center text-cyan-700 mb-1.5">
                            <span class="iconify" data-icon="ph:arrow-left-bold"></span>
                            <span class="text-[.78rem] transition-all ease-linear duration-300 pl-[3px] group-hover:tracking-widest tracking-wider font-bold">PREVIOUS</span>
                        </span>
                        <h4 class="text-[1.1rem] font-semibold text-left" v-html="prevStory.title"></h4>
                    </Link>

                    <Link :href="`${props.urlPrefix}/stories/${nextStory.slug}`" class="nav-item group pl-[15px] transition-opacity hover:opacity-80 duration-300 relative w-1/2 max-w-[215px] flex flex-col items-end">
                        <span class="flex items-center text-cyan-700 mb-1.5">
                            <span class="text-[.78rem] transition-all ease-in duration-300 pr-[3px] group-hover:tracking-widest tracking-wider font-bold">NEXT</span>
                            <span class="iconify" data-icon="ph:arrow-right-bold"></span>
                        </span>
                        <h4 class="text-[1.1rem] font-semibold text-right" v-html="nextStory.title"></h4>
                    </Link>
                </div>

            </div>



            <div class="author-meta flex items-start " v-if="story.user" :class="{ 'relative text-zinc-300 border-top-dotted pt-7': stories.length <= 1  }">
                <div class="author-avatar flex-shrink-0 border-[3px] border-white shadow w-[90px] h-[90px] rounded-full overflow-hidden" v-if="story.user.avatar">
                    <img :src="story.user.avatar" class="block w-full h-full object-cover" />
                </div>
                <div class="center-wrap self-stretch flex items-center ml-6 mr-5">
                <div class="author-bio text-body">
                    <h4 v-html="story.user.full_name" class="font-semibold leading-tight text-[1rem] mb-[5px]"></h4>
                    <div class="bio leading-snug font-serif text-[.84rem]" v-html="story.user.bio" v-if="story.user.bio"></div>
                </div>

                </div>
            </div>

        </article>

        <teleport v-if="isMounted" to=".action-slot">
            <div class="story-navigation flex items-center mt-7 drop-shadow-none shadow-none" v-if="stories.length > 1">
                <Link :href="`${props.urlPrefix}/stories/${prevStory.slug}`" class="nav-item relative cursor-pointer group transition-opacity duration-500 ease-out hover:opacity-100 opacity-90 flex items-center justify-center flex-shrink-0 rounded-full w-[34px] h-[34px]">
                    <span class="iconify " data-icon="ph:arrow-left-bold"></span>
                    <span class="absolute hidden md:block pointer-events-none whitespace-nowrap transition-block-image origin-left translate-x-2 group-hover:translate-x-0 group-hover:opacity-100 opacity-0 text-[.9rem] font-semibold font-serif rounded-sm px-2 py-0.5 top-1/2 -translate-y-1/2 bg-black text-white left-full ml-2" v-text="prevStory.title"></span>

                    <svg class="circle-border absolute z-[-1] top-0 right-0 group-hover:animate-rotate w-full h-full">
                        <circle cx="50%" cy="50%" r="46%"></circle>
                    </svg>
                </Link>
                <svg class="line-border flex-grow mx-2 h-[2px] z-[-1] w-full">
                    <line x1="0" y1="50%" x2="100%" y2="50%"  />
                </svg>
                <Link :href="`${props.urlPrefix}/stories/${nextStory.slug}`" class="nav-item relative cursor-pointer group transition-opacity duration-500 ease-out hover:opacity-100 opacity-90 flex items-center justify-center flex-shrink-0 rounded-full w-[34px] h-[34px]">
                    <span class="iconify" data-icon="ph:arrow-right-bold"></span>
                    <span class="absolute hidden md:block pointer-events-none whitespace-nowrap shadow-none drop-shadow-none transition-block-image origin-left -translate-x-2 group-hover:translate-x-0 group-hover:opacity-100 opacity-0 text-[.9rem] font-semibold font-serif rounded-sm px-2 py-0.5 top-1/2 -translate-y-1/2 bg-black text-white right-full mr-2" v-text="nextStory.title"></span>
                    <svg class="circle-border absolute z-[-1] top-0 right-0 group-hover:animate-rotate w-full h-full">
                        <circle cx="50%" cy="50%" r="46%"></circle>
                    </svg>
                </Link>
            </div>
            <div class="story-nav-filler mt-7" v-if="stories.length == 1">
                <svg class="line-border flex-grow mx-2 h-[2px] z-[-1] w-full">
                    <line x1="0" y1="50%" x2="100%" y2="50%"  />
                </svg>
            </div>
        </teleport>

        <teleport to="body">
           <related-content :related="story.related_items" v-if="story.related_items.length">
           </related-content>
        </teleport>

        <ContactForm :account="account" :guide="guide"></ContactForm>

    </div>
</template>
<script setup>
    import { format, parseJSON } from 'date-fns'
    //import { debouncedWatch } from "@vueuse/shared";
    import { computed, inject, onMounted, ref } from "vue";
    //import { useRemember } from '@inertiajs/inertia-vue3';
    import GridBlock from './Partials/GridBlock.vue'

    import { reduce, sample } from 'underscore'

    import { Inertia } from '@inertiajs/inertia';



    /*import {
        extract
    } from 'oembed-parser';*/
    console.log('only fire once')

    const props = defineProps({
        account: {},
        guide: {},
        stories: {
            type: Array,
            default: []
        },
        story: {},
        urlPrefix: {
            default: ''
        }
    })


    const isMounted = ref(false)

    const sharedData = inject('sharedData')

    sharedData.value.subtitle = computed( () => {
        //if ( props.story.expires ) return format(parseJSON( props.story.start_date ), 'MMM d, yyyy')
        return publishedAt.value;
        return null
        return format(parseJSON( props.story.published_at ), 'MMM d, yyyy')
    } )
    sharedData.value.author = computed( () => {
        //if ( props.story.expires ) return format(parseJSON( props.story.start_date ), 'MMM d, yyyy')
        //return format(parseJSON( props.story.published_at ), 'MMM d, yyyy')
        return props.story.author || null
    } )

    sharedData.value.subheading = computed( () => {
        /*let fragments = ['city', 'state']

        let location = []
        fragments.forEach( (fragment) => {
           if (props.story[fragment]) {
               location.push( props.story[fragment] )
           }
        } )

        if ( fragments.length ) return location.join(', ');*/
        /*let textParts = []
        if ( props.story.city ) textParts.push( `<span class="italic">${props.story.city}</span>` )
        if ( props.story.state ) textParts.push( `${props.story.state}`)
        return textParts.length ? textParts.join(', ') : false*/
        return null
    } )

    sharedData.value.backgroundImage = props.story.images.retina

    const publishedAt = computed( () => {
        let m = format(parseJSON( props.story.published_at ), 'MMMM');
        let d = format(parseJSON( props.story.published_at ), 'd, yyyy');
        return `<span class="italic">${m}</span> <span>${d}</span>`
        //return format(parseJSON( props.story.published_at ), 'MMMM d, yyyy')
    } )
    const storyIndex = computed( () => {
        return props.stories.findIndex( (story) => {
            return props.story.id == story.id
        });
    })

    const nextStory = computed(() => {

        if ( storyIndex.value == -1 ) {
            return props.stories[0]
        }

        let nextIndex = storyIndex.value + 1;
        if ( nextIndex == props.stories.length ) nextIndex = 0;
        return props.stories[nextIndex]
    })
    const prevStory = computed(() => {

        if ( storyIndex.value == -1 ) {
            return props.stories[ props.stories.length - 1 ]
        }

        let prevIndex = storyIndex.value == 0 ? props.stories.length - 1 : storyIndex.value - 1
        return props.stories[prevIndex]
    })

    onMounted( () => {


        if ( document.querySelector('.block-0').classList.contains('row-editor') ) {

            let el = document.querySelector('.block-0 p:first-child');


            if ( el && el.clientHeight >= 78 ) {
                el.classList.add( 'has-initial' )
            }
        }

        if ( isMounted.value == false ) {
            document.querySelectorAll( 'oembed[url]' ).forEach( async (element) => {
                iframely.load( element, element.attributes.url.value );
                /*let oembed = await extract(element.attributes.url.value);

                if ( !!oembed.html ) {
                    element.insertAdjacentHTML('afterend', oembed.html);
                }*/

            } );
        }

        isMounted.value = true


    })



    defineExpose(

    )

</script>
<style lang="scss">

    article {
        .prose {
            h4 + h5.subheader, h3 + h5.subheader {
                margin-top: -.75rem;
            }
            figure.image {
                margin: .9rem auto;


                img {
                    display: block;
                    border-radius: 4px;
                }
                figcaption {
                    margin: 0;
                    padding: 5px 0;
                    text-align: center;
                }
            }
            p img {
                margin: 0;
                display: block;
            }
            *:first-child {
                margin-top: 0!important;
            }
            *:last-child {
                margin-bottom: 0!important;
            }
        }
    }
    .row-blockquote {
        position: relative;
        z-index: 1;
        overflow: hidden;
        .blockquote-bg {
            -webkit-text-stroke: 2px #eeeeee;
            width: 100%;
            text-stroke: 2px #eeeeee;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            min-height: 100px;
            max-height: 200px;
            height: 100%;
            pointer-events: none;
            z-index: -1;
            img {
                object-fit: cover;
                height: 100%;
                width: auto;
            }
        }
        .blockquote-body {
            width: 100%;
            padding: 2rem 0;
            .blockquote-input {
                border: none;
                outline: none;
                box-shadow: none!important;
                background: none;
                font-family: 'Playfair Display', serif;
                font-style: italic;
                width: 100%;
                font-size: 1.4rem;
                line-height: 1.8rem;
                letter-spacing: .02rem;
                color: #444;
                padding: 0 2rem;
                max-width: 560px;
                font-weight: 500;
            }
        }

    }
    .grid-block {
        .prose {
            img {
                margin-bottom: 0;
            }
        }
    }

</style>
